<template lang="pug">
  .modal__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'ModalPreloader'
}
</script>
